<template>
    <div class="columns is-centered mt-6 mb-6">
        <div class="column is-12 box is-block is-radiusless has-text-centered">
            <BaseReport :signalRSocket="signalRSocket" />
            <hr />
            <IntervalReport :signalRSocket="signalRSocket" class="mt-4" />
        </div>
    </div>
</template>

<script>
import BaseReport from "./BaseReport.vue";
import IntervalReport from "./IntervalReport.vue";

export default {
    name: "supervisor-report",
    components: {
        BaseReport,
        IntervalReport
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
    },
};
</script>